import React from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import InfoCard from '../../components/ui/InfoCard'; // Import the new InfoCard component

// Import images - adjust paths as necessary
import currentItineraryImage from '../../assets/img/reservation-mexico.png';
// For visited destinations, using URLs from HTML as placeholders. 
// Consider downloading and importing locally if preferred for consistency.
const visitedDestinationImage1 = 'https://images.unsplash.com/photo-1648742867716-0833f28b0c00?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';
const visitedDestinationImage2 = 'https://images.unsplash.com/photo-1616423841125-8307665a0469?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

// Placeholder data - in a real app, this would come from props or an API
const currentItineraryData = {
    destination: "Ciudad de México",
    image: currentItineraryImage,
    dateRange: "Abril a 15 Mayo",
    peopleCount: "2 personas",
    duration: "4 Noches - 5 días",
    accommodation: 'Alojamiento Hotel "Ciudad de México"',
    flightInfo: "Vuelo directo",
    routeFrom: "SCL",
    routeTo: "DF",
    itineraryLink: "/itinerary/1" // Example link, adjust as per your routing
};

const visitedDestinationsData = [
    {
        id: "dest1",
        imageUrl: visitedDestinationImage1,
        title: "San Andrés - Colombia",
        detailsLink: "/itinerary/archive/1" // Example link
    },
    {
        id: "dest2",
        imageUrl: visitedDestinationImage2,
        title: "Cancún - México",
        detailsLink: "/itinerary/archive/2" // Example link
    }
];

const ItineraryListUserScreen = () => {
    return (
        <DashboardLayout activeMenuItem="Mis Rutas" isScrollable={true}>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2">
                <h1 className="h2 mb-4">Mis Rutas</h1>
            </div>

            <div className="row text-start mb-4">
                <div className="col-12">
                    <div className="card card-metric border-0">
                        <div className="card-body px-md-2 px-0">
                            <div className="row gap-3">
                                <div className="col-md-5 text-start">
                                    <img src={currentItineraryData.image} className="img-fluid image-reservation" alt={`Imagen de ${currentItineraryData.destination}`} />
                                </div>
                                <div id="reservationDetailsResume" className="col-md-7 text-start">
                                    <h3 className="mb-4">Viaje soñado a “{currentItineraryData.destination}”</h3>
                                    <div className="d-flex flex-wrap justify-content-start align-items-center mb-4 gap-4">
                                        <span className="badge reservation-badge reservation-badge-date">
                                            <i className="bi bi-calendar-event me-2"></i>
                                            <span>{currentItineraryData.dateRange}</span>
                                        </span>
                                        <span className="badge reservation-badge reservation-badge-people-count">
                                            <i className="bi bi-people me-2"></i>
                                            <span>{currentItineraryData.peopleCount}</span>
                                        </span>
                                    </div>
                                    <h4 className="mb-3">Detalles:</h4>
                                    <div className="d-flex align-items-start flex-column mb-4 gap-3">
                                        <span className="badge reservation-badge reservation-badge-duration">
                                            <i className="bi bi-clock-history me-2"></i>
                                            <span>{currentItineraryData.duration}</span>
                                        </span>
                                        <span className="badge reservation-badge reservation-badge-accommodation-info">
                                            <i className="bi bi-building me-2"></i>
                                            <span>{currentItineraryData.accommodation}</span>
                                        </span>
                                        <span className="badge reservation-badge reservation-badge-flight-info">
                                            <i className="bi bi-airplane me-2"></i>
                                            <span>{currentItineraryData.flightInfo}</span>
                                        </span>
                                        <span className="badge reservation-badge reservation-badge-route">
                                            <span>{currentItineraryData.routeFrom}</span>
                                            <i className="bi bi-arrow-left-right icon-separator mx-1"></i>
                                            <span>{currentItineraryData.routeTo}</span>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <button className="btn btn-outline-checkin">Descargar itinerario</button>
                                        <Link to={currentItineraryData.itineraryLink} className="btn btn-checkin">Ver mi itinerario</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h3 className="mb-2">Tus últimos destinos visitados</h3>
            </div>
            <div className="row text-start pb-5 gap-4">
                {visitedDestinationsData.map((destination) => (
                    <InfoCard
                        key={destination.id}
                        imageUrl={destination.imageUrl}
                        imageAlt={`Destino ${destination.title}`}
                        title={destination.title}
                        linkTo={destination.detailsLink}
                        colClasses="col-md-3" // Override default to remove mb-3 if not needed here
                        cardClasses="card card-destination border-0" // Custom card class
                    />
                ))}
            </div>
        </DashboardLayout>
    );
};

export default ItineraryListUserScreen;